import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=6b606d24&scoped=true"
import script from "./ReviewPage.vue?vue&type=script&lang=js"
export * from "./ReviewPage.vue?vue&type=script&lang=js"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=6b606d24&prod&lang=scss&scoped=true"
import style1 from "./ReviewPage.vue?vue&type=style&index=1&id=6b606d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b606d24",
  null
  
)

export default component.exports